import { useEffect, useState } from 'react';
import styles from './Users.module.css'
import Checkbox from '../../compoenets/Checkbox'
import Dropdown from '../../compoenets/Dropdown';
import useApi from '../../services/useApi';
import { useRecoilState } from 'recoil';
import { namespaceState } from '../../recoil/atoms';
import ConfirmModal from '../../compoenets/ConfirmModal';

const Row = ({ nsId,data,onRefreshList }) => {
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [userData,setUserData]=useState(data);
    const [isConfirm,setIsConfirm]=useState(false);

    const handleChange=(checkName)=>{
        useApi.put('/ngp/namespace/user/byRoleName?namespaceId='+ nsId,{
            id: userData.id,
            namespaceUserRoleName: userData.namespaceUserRoleName,
            taskCreateYN: userData.taskCreateYN,
            taskDeleteYN: userData.taskDeleteYN,
            modelCreateYN: userData.modelCreateYN,
            modelDeleteYN: userData.modelDeleteYN,
            dashboardAccessYN: userData.dashboardAccessYN,
            activeYN: userData.activeYN,
            [checkName]:userData[checkName]=='Y'?'N':'Y'
        }).then((res)=>{
        })

        setUserData(prevState=>({
            ...prevState,
            [checkName]:prevState[checkName]=='Y'?'N':'Y'
        }))
    }

    const handleRoleChange=(nowRole)=>{
        useApi.put('/ngp/namespace/user/byRoleName?namespaceId='+ nsId,{
            id: userData.id,
            namespaceUserRoleName: nowRole,
            taskCreateYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.taskCreateYN,
            taskDeleteYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.taskDeleteYN,
            modelCreateYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.modelCreateYN,
            modelDeleteYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.modelDeleteYN,
            dashboardAccessYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.dashboardAccessYN,
            activeYN: userData.activeYN,
        }).then((res)=>{
        })

        setUserData(prevState=>({
            ...prevState,
            ["namespaceUserRoleName"]:nowRole,
            taskCreateYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.taskCreateYN,
            taskDeleteYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.taskDeleteYN,
            modelCreateYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.modelCreateYN,
            modelDeleteYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.modelDeleteYN,
            dashboardAccessYN: nowRole=="owner"?"Y":nowRole=="guest"?"N":userData.dashboardAccessYN,
        }))
    }

    const handleDelete=()=>{
        useApi.delete('ngp/namespace/user/force?namespaceId='+nsId+'&namespaceUserId='+data.id)
        .then((res)=>{
            onRefreshList();
        });
    }

    return (
        <>
        <tr className={styles['row']}>
            <td>
                <span>{userData.workspaceUserMail.split('@')[0]}</span><br/>
                <span>{userData.workspaceUserMail}</span>
            </td>
            <td>
                <Dropdown selected={userData.namespaceUserRoleName} onChange={handleRoleChange}/>
            </td>
            <td className={styles['checkbox']}>
                <Checkbox isChecked={userData.taskCreateYN=='Y'?1:0} onChange={()=>handleChange("taskCreateYN")} disabled={userData.namespaceUserRoleName!="member"?true:false}/>
            </td>
            <td className={styles['checkbox']}>
                <Checkbox isChecked={userData.taskDeleteYN=='Y'?1:0} onChange={()=>handleChange("taskDeleteYN")}disabled={userData.namespaceUserRoleName!="member"?true:false}/>
            </td>
            <td className={styles['checkbox']}>
                <Checkbox isChecked={userData.modelCreateYN=='Y'?1:0} onChange={()=>handleChange("modelCreateYN")} disabled={userData.namespaceUserRoleName!="member"?true:false}/>
            </td>
            <td className={styles['checkbox']}>
                <Checkbox isChecked={userData.modelDeleteYN=='Y'?1:0} onChange={()=>handleChange("modelDeleteYN")} disabled={userData.namespaceUserRoleName!="member"?true:false}/>
            </td>
            <td className={styles['checkbox']}>
                <Checkbox isChecked={userData.dashboardAccessYN=='Y'?1:0} onChange={()=>handleChange("dashboardAccessYN")} disabled={userData.namespaceUserRoleName!="member"?true:false}/>
            </td>
            <td className={styles['checkbox']}>
                <div className={styles['delete-icon']} onClick={()=>setIsConfirm(true)}></div>
            </td>
        </tr>
        {isConfirm&&<ConfirmModal
            title="Remove User"
            subTitle={"사용자 `"+`${userData.workspaceUserMail.split('@')[0]}`+"`을 제외하겠습니까?"}
            confirmText="Delete"
            cancelText="Cancel"
            onAction={handleDelete}
            onClose={()=>setIsConfirm(false)}
            />
        }
        </>
    );
};

export default function Users({refreshList}){
    const [tableData, setTableData] = useState([]);
    const [nsState,setNsState]=useRecoilState(namespaceState);

    useEffect(()=>{
        if(nsState.id==="")return;
        handleRefreshList();
    },[refreshList,nsState])

    const handleRefreshList=()=>{
        useApi.get('ngp/namespace/user/list?namespaceId='+ nsState.id).then((res)=>{
            setTableData(res.data);
        })
    }

    return(
        <div className={styles['wrap']}>
            <table>
                {/* <colgroup>
                    <col width="13%"/>
                    <col width="15%"/>
                    <col width="15%"/>
                    <col width="8%"/>
                    <col width="10%"/>
                    <col width="14%"/>
                    <col width="10%"/>
                    <col width="15%"/>
                </colgroup> */}
                <thead>
                    <tr className={styles["head"]}>
                        <th>
                            <span>Account</span>
                            <span className={styles['user-count']}>{tableData.length}</span>
                        </th>
                        <th>Role</th>
                        <th>Task Create</th>
                        <th>Task Remove</th>
                        <th>Model Upload</th>
                        <th>Model Remove</th>
                        <th>Dashboard Access</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((rowData) => (
                      <Row key={rowData.id} nsId={nsState.id} data={rowData} onRefreshList={handleRefreshList} />
                    ))}
                </tbody>
            </table>
        </div>
    )
}


